export const LEVELS = [
  'Beginner',
  'Elementary',
  'Intermediate',
  'Upper-Intermediate',
  'Advanced',
  'Proficiency',
  'Difficult',
];

export const SHORT_LEVELS = ['A1', 'A2', 'B1', 'B2', 'C1', 'C2', 'D'];

export const DIFFICULTY = {
  learning: 'learning',
  difficult: 'difficult',
  learned: 'learned',
};
